import { Observable } from 'rxjs/observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Injectable } from '@angular/core';


@Injectable()
export class TemplateService {

    designerSettings : BehaviorSubject<any> = new BehaviorSubject({});
    constructor() {
        if(localStorage.designerSettings){
            this.designerSettings.next(JSON.parse(localStorage.designerSettings));
        }else{
            let designerSettings = this.DefaultSettings();
            this.designerSettings.next(designerSettings);
        }
    }

    DefaultSettings(): any{
        let designerSettings = {
            sections: [
               
            ]
        }
        return designerSettings;
    }

    SetTemplate(designerSettings){
        this.designerSettings.next(designerSettings);
    }

}


// WEBPACK FOOTER //
// ./src/Services/TemplateService.ts